import "beefup/dist/js/jquery.beefup.min";
import barba from "@barba/core";

(function ($) {
	const initAccordion = () => {
		$(".accordion__item").beefup({
			trigger: ".accordion__header",
			content: ".accordion__body",
			openSingle: true,
			openSpeed: 500,
			closeSpeed: 500,
		});

		const accordionItems = document.querySelectorAll(".accordion__item");

		let animating = false;

		accordionItems.forEach((item) => {
			item.querySelector(".accordion__header").addEventListener(
				"click",
				() => {
					for (const accordionItem of accordionItems) {
						if (accordionItem == item) {
							continue;
						}
						accordionItem.classList.remove("wk-is-open");
					}

					if (!animating) {
						animating = true;
						item.classList.toggle("wk-is-open");
						setTimeout(() => {
							animating = false;
						}, 500);
					}
				}
			);
		});
	};

	barba.hooks.beforeEnter(initAccordion);
	document.addEventListener("DOMContentLoaded", initAccordion);
})(window.jQuery);
